// extracted by mini-css-extract-plugin
module.exports = {"bannerSection":"style_bannerSection__V5vlh","content":"style_content__W9EZd","person":"style_person___un6j","socialMenu":"style_socialMenu__GVjmu"};